module.exports = __webpack_public_path__ + "assets/img/07de717f20628272ea8a3ab07bc92e26.png";